import { averageScore } from './score'

export function makePlayers(count, names = []) {
  return Array.from({ length: count }, (_, i) => ({
    id: i,
    name: (names[i] && String(names[i]).trim()) || `Player ${i + 1}`,
    scores: [],
  }))
}

export function rankPlayers(players) {
  return [...players]
    .map((p) => ({ ...p, avg: averageScore(p.scores || []) }))
    .sort((a, b) => b.avg - a.avg)
}

export function winnerOf(players) {
  const ranked = rankPlayers(players)
  return ranked[0] || null
}
